import {BlobDto} from '../Blob/type'

export enum XpertKnowledgeSubSectionSource {
  TRANSCRIPT = 'TRANSCRIPT',
  DOCUMENTATION = 'DOCUMENTATION',
}

export interface XpertKnowledgeSectionDto {
  id: number
  title: string
  position: number
  intro: string
  conclusion: string
  subSections?: XpertKnowledgeSubSectionDto[]
}

export interface XpertKnowledgeSubSectionDto {
  id: number
  title: string
  position: number
  content: string
  medias: XpertKnowledgeSubSectionBlobDto[]
  startTimestamp?: string
  endTimestamp?: string
  source?: XpertKnowledgeSubSectionSource
}

export interface XpertKnowledgeSubSectionBlobDto {
  id: number
  isShow: boolean
  blob: BlobDto
  startTimestamp?: string
  endTimestamp?: string
}

export interface UpdateXpertKnowledgeSubclipBody {
  startTimestamp?: string
  endTimestamp?: string
}

export interface CreateXpertKnowledgeSectionBody {
  title: string
  position: number
  intro?: string
  conclusion?: string
}

export interface CreateXpertKnowledgeSubSectionBody {
  title: string
  position: number
  content?: string
  // blob?: BlobDto
}

export interface UpdateXpertKnowledgeSectionBody {
  title?: string
  position?: number
  intro?: string
  conclusion?: string
}

export interface UpdateXpertKnowledgeSubSectionBody {
  title?: string
  position?: number
  content?: string
  medias?: UpdateXpertKnowledgeSubSectionBlobBody[]
}

export interface UpdateXpertKnowledgeSubSectionBlobBody {
  id: number
  isShow: boolean
}
